module.exports = __webpack_public_path__ + "img/hero_cn.bcdf212.jpg";